import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import { ToastContainer, toast } from 'react-toastify';
import {useHistory} from 'react-router-dom';

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      name: "",
      no:"",
      city:"",
      vehicleType:"",
      hasAgreed: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    let target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    let name = target.name;

    this.setState({
      [name]: value
    });
  }
  
  handleSubmit(e) {
    e.preventDefault();
    try {
        const registered = {
          name: this.state.name,
          password: this.state.password,
          email: this.state.email,
          no: this.state.no,
          city: this.state.city,
          vehicleType: this.state.vehicleType
        }
        axios.post("/registerVehicle", registered)
        .then(response =>{
          if(response.status == 200) {
            toast.success("Added Successfully");
            window.location.href = "/vehicle#/react-auth-ui/sign-in"
          } else {
            toast.error("Something Went Wrong!");
          }
        })
    } catch(err) {
        console.log(err)
    }
  }

  render() {
    return (
      <div className="formCenter">
        <form onSubmit={this.handleSubmit} className="formFields">
          <div className="formField">
            <label className="formFieldLabel" htmlFor="name">
              Full Name
            </label>
            <input
              type="text"
              id="name"
              className="formFieldInput"
              placeholder="Enter your full name"
              name="name"
              value={this.state.name}
              onChange={this.handleChange}
            />
          </div>
          <div className="formField">
            <label className="formFieldLabel" htmlFor="email">
              Mobile Number
            </label>
            <input
              type="mob"
              id="no"
              className="formFieldInput"
              placeholder="Enter your mobile number"
              name="no"
              value={this.state.no}
              onChange={this.handleChange}
            />
          </div>
          <div className="formField">
            <label className="formFieldLabel" htmlFor="email">
              City
            </label>
            <input
              type="city"
              id="city"
              className="formFieldInput"
              placeholder="Enter your city"
              name="city"
              value={this.state.city}
              onChange={this.handleChange}
            />
          </div>
          <div className="formField">
            <label className="formFieldLabel" htmlFor="email">
              Vehicle Type
            </label>
            <input
              type="vehicle"
              id="vehicleType"
              className="formFieldInput"
              placeholder="Enter your vehicle type"
              name="vehicleType"
              value={this.state.vehicleType}
              onChange={this.handleChange}
            />
          </div>
          <div className="formField">
            <label className="formFieldLabel" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="formFieldInput"
              placeholder="Enter your password"
              name="password"
              value={this.state.password}
              onChange={this.handleChange}
            />
          </div>
          <div className="formField">
            <label className="formFieldLabel" htmlFor="email">
              E-Mail Address
            </label>
            <input
              type="email"
              id="email"
              className="formFieldInput"
              placeholder="Enter your email"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </div>

          <div className="formField">
            <label className="formFieldCheckboxLabel">
              <input
                className="formFieldCheckbox"
                type="checkbox"
                name="hasAgreed"
                value={this.state.hasAgreed}
                onChange={this.handleChange}
              />{" "}
              I agree all statements in{" "}
              <a href="null" className="formFieldTermsLink">
                terms of service
              </a>
            </label>
          </div>

          <div className="formField">
            <button className="formFieldButton">Sign Up</button>{" "}
            <Link to="/sign-in" className="formFieldLink">
              I'm already member
            </Link>
          </div>
        </form>
      </div>
    );
  }
}
export default SignUpForm;
